
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/handle-auth-urls",
      function () {
        return require("private-next-pages/customer-service/handle-auth-urls.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/handle-auth-urls"])
      });
    }
  